import {TouchTapEvent} from 'material-ui'
import Popover from 'material-ui-next/Popover/Popover'
import IconButton from 'material-ui/IconButton'
import ContentFilter from 'material-ui/svg-icons/content/filter-list'
import * as React from 'react'
import injectSheet from 'react-jss'
import {layers} from '../../Style'
import {WithClasses} from '../Helper'

interface Props {
    readonly filterForm: React.ReactNode
    readonly activeFiltersView: React.ReactNode
    readonly filterPopoverOpen: boolean
    readonly onFilterPopoverToggle: (open: boolean) => void
}

interface State {
    readonly filterPopoverAnchorElement?: HTMLElement
}

const styles = {
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginBottom: '32px',
        alignItems: 'center',
    },
    popover: {
        overflow: 'visible',
        '& .react-autosuggest__suggestions-container--open': {
            position: 'absolute',
            width: 'auto',
            zIndex: layers.middle,
            right: 0,
        }
    },
    popoverPaper: {
        overflow: 'visible',
    },
    filterIcon: {
        flexGrow: 0,
        flexShrink: 0,
        order: 2,
        textAlign: 'center',
    }
}

export const FilterContainer =
    injectSheet<Props>(styles)(
        class
            extends React.Component<WithClasses<Props>, State> {
            constructor(props: WithClasses<Props>) {
                super(props)
                this.state = {}
            }

            render() {
                const {
                    classes,
                    filterForm,
                    activeFiltersView,
                    filterPopoverOpen,
                    onFilterPopoverToggle,
                } = this.props
                return (
                    <div className={classes.root}>
                        <IconButton
                            onTouchTap={(event: TouchTapEvent) => {
                                this.setState({
                                    filterPopoverAnchorElement: event.currentTarget as HTMLElement,
                                })
                                onFilterPopoverToggle(true)
                            }}
                            className={classes.filterIcon}
                        >
                            <ContentFilter/>
                        </IconButton>
                        <Popover
                            open={filterPopoverOpen}
                            anchorEl={this.state.filterPopoverAnchorElement}
                            anchorOrigin={{
                                horizontal: 'right',
                                vertical: 'bottom'
                            }}
                            transformOrigin={{
                                horizontal: 'right',
                                vertical: 'top'
                            }}
                            onClose={() => onFilterPopoverToggle(false)}
                            className={classes.popover}
                            classes={{paper: classes.popoverPaper}}
                        >
                            {filterForm}
                        </Popover>
                        {activeFiltersView}
                    </div>
                )
            }
        }
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/Filtering/FilterContainer.tsx